import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { withStyles } from 'src/app/helpers/styles';

interface MyProps {
  formattedMessageId: string;
  formattedMessageValue?: {};
  toastEndCallback?: VoidFunction;
}

interface MyState {
  isActive: boolean;
}

@withStyles({
  base: [require('./Toast.base.scss')],
  desktop: [require('./Toast.desktop.scss')]
})
export class Toast extends React.Component<MyProps, MyState> {
  private timeoutAnimate: number;
  private timeoutDissapear: number;

  constructor(props: MyProps) {
    super(props);

    this.state = { isActive: true };
  }

  componentWillUnmount(): void {
    clearTimeout(this.timeoutAnimate);
    clearTimeout(this.timeoutDissapear);
  }

  componentDidMount(): void {
    this.timeoutAnimate = window.setTimeout(() => {
      const { toastEndCallback } = this.props;

      this.setState({ isActive: false });
      if (toastEndCallback) {
        this.timeoutDissapear = window.setInterval(() => { toastEndCallback(); }, 500);
      }
    }, 1500);
  }

  render(): JSX.Element {
    const { formattedMessageId, formattedMessageValue } = this.props;
    const className = classnames('fg-black bg-white radius-small fs-14 px-16 py-14 position-relative b-0 d-flex ai-center toast__content', { 'toast__content--active': this.state.isActive });
    return (
      <div className="px-16 my-8 px@md-0 w-100 toast">
        <FormattedMessage id={formattedMessageId} values={formattedMessageValue}>
          {(message) => <div className={className}>{message}</div>}
        </FormattedMessage>
      </div>
    );
  }
}
